// extracted by mini-css-extract-plugin
export var btnBlock = "style-module--btn-block--d820e";
export var screen1 = "style-module--screen1--9a0db";